import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import Markdown from '../Markdown/Markdown'
import { ControlledModal } from '../Modal/Modal'
import { BASE_URL, GET } from 'requests'
import './DetailsList.scss'

export default class DetailsList extends Component {
  getDetailByType = (detail, i) => {
    switch (detail.TYPE) {
      case 'image':
        return <DetailImage label={detail.LABEL} src={detail.VALUE} key={i} />
      case 'download':
        return (
          <DetailDownload
            label={detail.LABEL}
            linklabel={detail.LINKLABEL}
            src={detail.VALUE}
            key={i}
          />
        )
      case 'url':
        return (
          <DetailUrl label={detail.LABEL} linklabel={detail.LINKLABEL} src={detail.VALUE} key={i} />
        )
      case 'markdown':
        return <DetailMarkdown label={detail.LABEL} value={detail.VALUE} key={i} />
      case 'apimodal':
      case 'modal':
        return (
          <DetailMarkdownModal
            label={detail.LABEL}
            linklabel={detail.LINKLABEL}
            modalTitle={detail.TITLE}
            modalSize={detail.MODAL_SIZE}
            modalBody={detail.MODAL_BODY}
            src={detail.VALUE}
            key={i}
          />
        )
      default:
        return <Detail label={detail.LABEL} value={detail.VALUE} alert={detail.ALERT_YN} key={i} />
    }
  }
  render() {
    const { details = [] } = this.props
    return (
      <Fragment>
        <hr className="details-divider" />
        <table className="details-list container-fluid">
          <tbody>
            {details.map((detail, i) =>
              detail.VALUE === null ? null : this.getDetailByType(detail, i)
            )}
          </tbody>
        </table>
        <hr className="details-divider" />
      </Fragment>
    )
  }
}

const TableDivider = () => (
  <tr aria-hidden={true}>
    <td colSpan={2}>
      <hr className="details-divider" />
    </td>
  </tr>
)

const Detail = ({ label, value, alert, markdown }) => (
  <tr className={'detail ' + (alert ? 'alert' : '')}>
    <td className="label">{label}</td>
    <td className="value">
      {Array.isArray(value) ? (
        <ul>
          {value.map((li, i) => (
            <li key={i}>{li}</li>
          ))}
        </ul>
      ) : (
        value
      )}
    </td>
  </tr>
)

const DetailMarkdown = ({ label, value }) => (
  <React.Fragment>
    <TableDivider />
    {label ? (
      <tr className="detail">
        <td className="label full-width" colSpan="2">
          {label}
        </td>
      </tr>
    ) : null}
    <tr className="detail markdown-cell">
      <td className="value" colSpan="2">
        <Markdown className="markdown" source={value} />
      </td>
    </tr>
    <TableDivider />
  </React.Fragment>
)

const DetailMarkdownModal = ({
  alert,
  label,
  linklabel,
  src,
  modalTitle,
  modalSize,
  modalBody,
}) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const [modalMarkdown, setModalMarkdown] = React.useState(modalBody)
  const [error, setError] = React.useState('')

  const getModalMarkdown = (url) => {
    GET(
      url,
      (result) => {
        setModalMarkdown(result)
        setIsOpen(true)
        setError('')
      },
      (error) => {
        setError(error)
        console.error(error)
      }
    )
  }

  const handleOnClick = () => {
    if (src) {
      getModalMarkdown(src)
    } else {
      setIsOpen(!isOpen)
    }
  }

  return (
    <React.Fragment>
      <tr className={'detail ' + (alert ? 'alert' : '')}>
        <td className="label">{label}</td>
        <td className="value">
          <button className="modal-link" onClick={() => handleOnClick()}>
            {linklabel}
          </button>
          {error !== '' ? <p className="error">There was an error retrieving the data</p> : null}
        </td>
      </tr>
      <ControlledModal
        isOpen={isOpen}
        onRequestModalClose={() => setIsOpen(false)}
        onModalClosed={() => setIsOpen(false)}
        modalSize={modalSize}
        title={modalTitle}
      >
        <div className="markdown-modal-wrapper">
          <Markdown className="markdown" source={modalMarkdown} />
        </div>
      </ControlledModal>
    </React.Fragment>
  )
}

const DetailDownload = ({ label, linklabel, src, alert }) => (
  <tr className={'detail ' + (alert ? 'alert' : '')}>
    <td className="label">{label}</td>
    <td className="value">
      <a href={BASE_URL + src}>{linklabel}</a>
    </td>
  </tr>
)

const DetailUrl = ({ label, linklabel, src, alert }) => (
  <tr className={'detail ' + (alert ? 'alert' : '')}>
    <td className="label">{label}</td>
    <td className="value">
      {!src.startsWith('http') ? <Link to={src}>{linklabel}</Link> : <a href={src}>{linklabel}</a>}
    </td>
  </tr>
)

const DetailImage = ({ label, src }) => (
  <tr>
    <td colSpan={2}>
      <hr className="details-divider" />
      {label && <span className="image-label">{label}</span>}
      <div className="image-wrapper">
        <img className="image" src={BASE_URL + src} alt={label} />
      </div>
    </td>
  </tr>
)



// WEBPACK FOOTER //
// ./src/components/DetailsList/DetailsList.js